// MG Product Swatches export: page Swatch Picker sections
window.MG_SWATCH_SETS = window.MG_SWATCH_SETS || {};
window.MG_SWATCH_SETS["Colors-PMK08"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 2,
      "shadow_size": 4,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 6,
      "product_image_padding": 3,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "selected_appearance": {
      "border_color": "#12316f",
      "border_size": 4,
      "shadow_size": 8,
      "background_color": "#f5f5f5",
      "border_scope": "image_text",
      "text_color": "#000000",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 12,
      "border_radius_px": 6,
      "image_radius_px": 4,
      "product_image_padding": 1,
      "gradient_color": "#dcdfc3",
      "gradient_angle": 42,
      "text_style": "normal"
    },
    "corner_radius_px": 6
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "more_popup_text": "More",
      "margin_top": 0,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 26115125772422,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1839623957-08fbb96080c7e0f4338da9db5003600a103af7f1530bc407964236426401c12f-d_200x150_1eb1599f-ab34-4e72-a538-a235e3ce8ecf.jpg?v=1715787114&width=400",
          "product_url": "/products/smoothfinish_white-oak_s",
          "product_id": 6985221570694,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pecan",
          "alt": "Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Pecan-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 29348766089350,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-wBox.png?v=1774542633&width=400",
          "product_url": "/products/smoothfinish_pecan_s",
          "product_id": 6877953884294,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_pecan_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BarnWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 24354906767494,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Counterop_bca04d5b-162f-46b9-9ec0-f0388303980c.jpg?v=1774640482&width=400",
          "product_url": "/products/smoothfinish_barn-wood_s",
          "product_id": 6877835460742,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_barn-wood_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WeatheredWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 29355008655494,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK08-wBox_68ab1fbc-ac65-4402-8ad0-64dfefa79968.png?v=1774640844&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_s",
          "product_id": 6877943398534,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BlackWalnut-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 29355025072262,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK08-wBox.png?v=1774641475&width=400",
          "product_url": "/products/smoothfinish_black-walnut_s",
          "product_id": 6877939073158,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_black-walnut_s",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "heading_justify": "left",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 20,
      "margin_bottom": 10,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 5,
      "swatches_per_row_desktop": 5,
      "swatches_per_row": 5,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 10,
      "padding_between_rows": 10,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "bottom",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteWash-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 24360716566662,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/03-Fireplace-Kit_0222cb08-f38c-47bf-b2a6-22d93dc3fb6f.jpg?v=1774644352&width=400",
          "product_url": "/products/smoothfinish_white-wash_s",
          "product_id": 6877955096710,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-wash_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry",
          "alt": "Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-VintageCherry-Smooth.jpg?",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 24356037918854,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Tabletop_5d3cc134-7717-46f4-9efa-f04a1f70f5ba.jpg?v=1774642697&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_s",
          "product_id": 6877952639110,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-DarkOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 29355088478342,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK08-wBox.png?v=1774642401&width=400",
          "product_url": "/products/smoothfinish_dark-oak_s",
          "product_id": 6877951754374,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_dark-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Java-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 24355671769222,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW-Instructions_c6339d6d-6bdb-4a4a-88f0-44e8f75cb124.jpg?v=1774644013&width=400",
          "product_url": "/products/smoothfinish_java_s",
          "product_id": 6877931274374,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_java_s",
            "text": "Shop"
          }
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_appearance_source": "custom",
          "button_width_percent": 100,
          "button_max_width_px": "0",
          "button_margin_top": "10",
          "button_justify": "left",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "preset_button_heading_justify": "left",
          "preset_button_image_height_mobile": "0",
          "preset_button_image_height_desktop": "0",
          "preset_button_border_color": "#000000",
          "preset_button_border_size": 20,
          "preset_button_shadow_size": 0,
          "preset_button_border_radius_px": 12,
          "preset_button_background_color": "#ffffff",
          "preset_button_text_color": "#000000",
          "preset_button_gradient_color": "#ffffff",
          "preset_button_gradient_angle": 180,
          "preset_button_background_image": "",
          "preset_button_background_image_style": "center",
          "preset_button_text_size_mobile": 0,
          "preset_button_text_size_desktop": 0,
          "preset_button_text_behavior": "wrap_text",
          "preset_button_text_style": "normal",
          "preset_button_image_radius_px": 12,
          "preset_button_product_image_padding": 0,
          "preset_button_border_scope": "image_text",
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Charcoal-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_charcoal_s",
          "product_id": 6877943005318,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_charcoal_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-OldOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 24355688611974,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Smooth_0e5d340c-32ef-4f4a-95a9-d128b519a944.jpg?v=1774643302&width=400",
          "product_url": "/products/smoothfinish_old-oak_s",
          "product_id": 6877954670726,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_old-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-RedMahogany-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_s",
          "product_id": 6877952213126,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-ClassicBlack-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_classic-black_s",
          "product_id": 6877939466374,
          "show_price": false,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_classic-black_s",
            "text": "Shop"
          }
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-PMK16"] = {
  "meta": {
    "match_settings_preset_key": "Colors-PMK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25503642714246,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Smooth-Small_JPEG_6aee08ea-148b-4830-b055-545cd3b6b94c.jpg?v=1774632644&width=400",
          "product_url": "/products/smoothfinish_white-oak_m",
          "product_id": 6985221406854,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-oak_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pecan",
          "alt": "Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Pecan-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354550853766,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK16-wBox.png?v=1774634877&width=400",
          "product_url": "/products/smoothfinish_pecan_m",
          "product_id": 6877953785990,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BarnWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24354549629062,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Counterop_899cdd0f-2003-4b2c-8e37-dd7aff7e470d.jpg?v=1774635340&width=400",
          "product_url": "/products/smoothfinish_barn-wood_m",
          "product_id": 6877835133062,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WeatheredWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354574348422,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK16-Products-Retail.png?v=1774635696&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_m",
          "product_id": 6877943300230,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BlackWalnut-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354582966406,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK16-wBox.png?v=1774636083&width=400",
          "product_url": "/products/smoothfinish_black-walnut_m",
          "product_id": 6877938974854,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteWash-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24360707784838,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/01-Decking.jpg?v=1774639437&width=400",
          "product_url": "/products/smoothfinish_white-wash_m",
          "product_id": 6877954998406,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry",
          "alt": "Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-VintageCherry-Smooth.jpg?",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355968417926,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-Door_74a83f63-98d4-4cc9-84c8-39886cc86959.jpg?v=1774637716&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_m",
          "product_id": 6877952540806,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-DarkOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354610032774,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK16-wBox.png?v=1774637440&width=400",
          "product_url": "/products/smoothfinish_dark-oak_m",
          "product_id": 6877951656070,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Java-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_java_m",
          "product_id": 6877931077766,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Charcoal-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_charcoal_m",
          "product_id": 6877942907014,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-OldOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_old-oak_m",
          "product_id": 6877954572422,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-RedMahogany-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_m",
          "product_id": 6877952082054,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-ClassicBlack-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354641490054,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK16-wBox.png?v=1774638723&width=400",
          "product_url": "/products/smoothfinish_classic-black_m",
          "product_id": 6877939368070,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-PMK32"] = {
  "meta": {
    "match_settings_preset_key": "Colors-PMK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25503620104326,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Counterop-Smooth_561c3dd8-57e0-4fcc-8e3f-3c4cd4dfffea.jpg?v=1774877317&width=400",
          "product_url": "/products/smoothfinish_white-oak_l",
          "product_id": 6985221472390,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-oak_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pecan",
          "alt": "Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Pecan-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355127079046,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK32-wBox.png?v=1774645225&width=400",
          "product_url": "/products/smoothfinish_pecan_l",
          "product_id": 6877953818758,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BarnWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24354510569606,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Counterop_86005c6d-2732-4059-8856-17d68d4a5023.jpg?v=1774877802&width=400",
          "product_url": "/products/smoothfinish_barn-wood_l",
          "product_id": 6877835264134,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WeatheredWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25547369480326,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Smooth_54be13a8-5baf-42cb-bbd4-840df8f535a3.jpg?v=1774878305&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_l",
          "product_id": 6877943332998,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BlackWalnut-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29281464418438,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-BWAL-wBox.png?v=1773671391&width=400",
          "product_url": "/products/smoothfinish_black-walnut_l",
          "product_id": 6877939007622,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteWash-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24360675934342,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door_84621328-cc52-4351-b407-7d74e7de8a42.jpg?v=1774882137&width=400",
          "product_url": "/products/smoothfinish_white-wash_l",
          "product_id": 6877955031174,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry",
          "alt": "Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-VintageCherry-Smooth.jpg?",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355444228230,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door_69c989f7-d395-46b6-9ecd-dba26bf910af.jpg?v=1774880100&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_l",
          "product_id": 6877952573574,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-DarkOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29281502822534,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-DOAK-wBox.png?v=1773672181&width=400",
          "product_url": "/products/smoothfinish_dark-oak_l",
          "product_id": 6877951688838,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Java-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_java_l",
          "product_id": 6877931143302,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Charcoal-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_charcoal_l",
          "product_id": 6877942939782,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-OldOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_old-oak_l",
          "product_id": 6877954605190,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-RedMahogany-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_l",
          "product_id": 6877952114822,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-ClassicBlack-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29371865006214,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK32-Box-Hero_bd18804a-93c7-447a-b631-1f600d84234f.png?v=1774881583&width=400",
          "product_url": "/products/smoothfinish_classic-black_l",
          "product_id": 6877939400838,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-PMK128"] = {
  "meta": {
    "match_settings_preset_key": "Colors-PMK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25503450955910,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-Door-Smooth.jpg?v=1774883792&width=400",
          "product_url": "/products/smoothfinish_white-oak_xl",
          "product_id": 6985221537926,
          "price": "$299.99",
          "price_num": 299.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-oak_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pecan",
          "alt": "Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Pecan-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29372179644550,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK128-wBox_22582915-56d8-45b4-ac70-bb5fce69a3a0.png?v=1774888660&width=400",
          "product_url": "/products/smoothfinish_pecan_xl",
          "product_id": 6877953851526,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BarnWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24359183646854,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Decking_56f9f72b-cb7b-4b30-8162-4eb692a71587.jpg?v=1774884714&width=400",
          "product_url": "/products/smoothfinish_barn-wood_xl",
          "product_id": 6877835362438,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WeatheredWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25547274911878,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Smooth_a4292177-ae68-41d4-97f1-da3bc3c82eb0.jpg?v=1774885279&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_xl",
          "product_id": 6877943365766,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BlackWalnut-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29371980284038,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK128-wBox_43e3c83c-b68c-4510-a9e6-838115077508.png?v=1774885770&width=400",
          "product_url": "/products/smoothfinish_black-walnut_xl",
          "product_id": 6877939040390,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteWash-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24360630485126,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Fireplace-Kit_c19e13ea-8919-4f20-a8f1-857191b5e615.jpg?v=1774892623&width=400",
          "product_url": "/products/smoothfinish_white-wash_xl",
          "product_id": 6877955063942,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry",
          "alt": "Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-VintageCherry-Smooth.jpg?",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355059368070,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door_e1e50a79-bd5c-4869-8d87-6865fd6f6e86.jpg?v=1774889337&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_xl",
          "product_id": 6877952606342,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-DarkOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29372206645382,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK128-wBox.png?v=1774889063&width=400",
          "product_url": "/products/smoothfinish_dark-oak_xl",
          "product_id": 6877951721606,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Java-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24367807004806,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-Door_d8e72361-9f17-46ca-a980-870d46ed0781.jpg?v=1774892185&width=400",
          "product_url": "/products/smoothfinish_java_xl",
          "product_id": 6877931208838,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Charcoal-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24367562391686,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Cabinets_db5bd53f-e51b-4cfa-b9d0-ebe2d5c3721c.jpg?v=1774888773&width=400",
          "product_url": "/products/smoothfinish_charcoal_xl",
          "product_id": 6877942972550,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-RedMahogany-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_xl",
          "product_id": 6877952147590,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-OldOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_old-oak_xl",
          "product_id": 6877954637958,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-ClassicBlack-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29372480553094,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK128-Hero-Box.png?v=1774891850&width=400",
          "product_url": "/products/smoothfinish_classic-black_xl",
          "product_id": 6877939433606,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-PMK08-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-PMK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24360718762118,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Z-SmoothFinish-Instructions_5ed8ba85-6581-492a-99a3-32db0e1cd6fe.jpg?v=1774644517&width=400",
          "product_url": "/products/smoothfinish_white-wash_s_polytique-it",
          "product_id": 6877955129478,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pecan",
          "alt": "Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Pecan-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 28986066337926,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-59_3e482cd5-7ab9-4c6e-a537-d4b8e5222e42.png?v=1769444947&width=400",
          "product_url": "/products/smoothfinish_pecan_s_polytique-it",
          "product_id": 6877953917062,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BarnWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24354901819526,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor_08834112-03fd-4153-8fc9-0f1857de2142.jpg?v=1774640648&width=400",
          "product_url": "/products/smoothfinish_barn-wood_s_polytique-it",
          "product_id": 6877835559046,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WeatheredWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355011244166,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK08-PLTQM-wBox.png?v=1774641000&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_s_polytique-it",
          "product_id": 6877943431302,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BlackWalnut-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355028283526,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK08-PLTQM-wBox.png?v=1774641685&width=400",
          "product_url": "/products/smoothfinish_black-walnut_s_polytique-it",
          "product_id": 6877939105926,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteWash-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24360718762118,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Z-SmoothFinish-Instructions_5ed8ba85-6581-492a-99a3-32db0e1cd6fe.jpg?v=1774644517&width=400",
          "product_url": "/products/smoothfinish_white-wash_s_polytique-it",
          "product_id": 6877955129478,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry",
          "alt": "Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-VintageCherry-Smooth.jpg?",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24356039426182,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Smooth-Small_1a6ad5ad-ad63-40bd-a5f7-a1d53062fcdb.jpg?v=1774642873&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_s_polytique-it",
          "product_id": 6877952671878,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-DarkOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355092181126,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK08-PLTQM-wBox.png?v=1774642606&width=400",
          "product_url": "/products/smoothfinish_dark-oak_s_polytique-it",
          "product_id": 6877951787142,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Java-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355675308166,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW-Instructions_20dec0c0-519c-4ad6-aad4-2661a73822fc.jpg?v=1774644256&width=400",
          "product_url": "/products/smoothfinish_java_s_polytique-it",
          "product_id": 6877931307142,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Charcoal-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24354990194822,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW-Instructions_7ba18924-d3e3-4eea-8a0b-8ef8206981fd.jpg?v=1774642246&width=400",
          "product_url": "/products/smoothfinish_charcoal_s_polytique-it",
          "product_id": 6877943038086,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-OldOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_old-oak_s_polytique-it",
          "product_id": 6877954703494,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-RedMahogany-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355103322246,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK08-PLTQG-wBox.png?v=1774643202&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_s_polytique-it",
          "product_id": 6877952245894,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-ClassicBlack-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355111776390,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK08-PLTQG-wBox.png?v=1774643807&width=400",
          "product_url": "/products/smoothfinish_classic-black_s_polytique-it",
          "product_id": 6877939499142,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-PMK16-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-PMK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26115125772422,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1839623957-08fbb96080c7e0f4338da9db5003600a103af7f1530bc407964236426401c12f-d_200x150_1eb1599f-ab34-4e72-a538-a235e3ce8ecf.jpg?v=1715787114&width=400",
          "product_url": "/products/smoothfinish_white-oak_m_polytique-it",
          "product_id": 6985221668998,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-oak_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pecan",
          "alt": "Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Pecan-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354555342982,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK16-PLTQM-wBox.png?v=1774635035&width=400",
          "product_url": "/products/smoothfinish_pecan_m_polytique-it",
          "product_id": 6877953949830,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BarnWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24354946056326,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor_fc1bf7b0-b4d7-4788-927b-640733e00c53.jpg?v=1774635581&width=400",
          "product_url": "/products/smoothfinish_barn-wood_m_polytique-it",
          "product_id": 6877835624582,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WeatheredWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355999088774,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW-Instructions_58420483-7846-48ca-85ef-64823a6187c4.jpg?v=1774635909&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_m_polytique-it",
          "product_id": 6877943464070,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BlackWalnut-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354585587846,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK16-PLTQM-wBox.png?v=1774636264&width=400",
          "product_url": "/products/smoothfinish_black-walnut_m_polytique-it",
          "product_id": 6877939138694,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteWash-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24360712175750,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Z-SmoothFinish-Instructions_17fee3b1-f3b0-4bfa-bf1c-265e203f97e9.jpg?v=1774639766&width=400",
          "product_url": "/products/smoothfinish_white-wash_m_polytique-it",
          "product_id": 6877955162246,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry",
          "alt": "Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-VintageCherry-Smooth.jpg?",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355974185094,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door_4d155cc3-3779-45ed-9fbe-6aeda07287cd.jpg?v=1774637914&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_m_polytique-it",
          "product_id": 6877952704646,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-DarkOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354613211270,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK16-PLTQM-wBox.png?v=1774637603&width=400",
          "product_url": "/products/smoothfinish_dark-oak_m_polytique-it",
          "product_id": 6877951819910,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Java-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354658398342,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-BPK16-PLTQS-wBox.png?v=1774639319&width=400",
          "product_url": "/products/smoothfinish_java_m_polytique-it",
          "product_id": 6877931339910,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Charcoal-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354598432902,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-BPK16-PLTQG-wBox.png?v=1774636896&width=400",
          "product_url": "/products/smoothfinish_charcoal_m_polytique-it",
          "product_id": 6877943070854,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-OldOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354635427974,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-BPK16-PLTQS-wBox.png?v=1774638617&width=400",
          "product_url": "/products/smoothfinish_old-oak_m_polytique-it",
          "product_id": 6877954736262,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-RedMahogany-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354625826950,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK16-PLTQS-wBox.png?v=1774638190&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_m_polytique-it",
          "product_id": 6877952278662,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-ClassicBlack-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29462649143430,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK16-CBLK-PLTQ-Gloss-CBLK.png?v=1776263175&width=400",
          "product_url": "/products/smoothfinish_classic-black_m_polytique-it",
          "product_id": 6877939531910,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-PMK32-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-PMK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24360687206534,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Z-SmoothFinish-Instructions.jpg?v=1774882229&width=400",
          "product_url": "/products/smoothfinish_white-wash_l_polytique-it",
          "product_id": 6877955195014,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pecan",
          "alt": "Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Pecan-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355132420230,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK32-PLTQM-wBox.png?v=1774645506&width=400",
          "product_url": "/products/smoothfinish_pecan_l_polytique-it",
          "product_id": 6877953982598,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BarnWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_barn-wood_l_polytique-it",
          "product_id": 6877835755654,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WeatheredWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25547382456454,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Smooth_8a5f9e7b-6511-4048-a4bf-7adc8d958014.jpg?v=1774878461&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_l_polytique-it",
          "product_id": 6877943496838,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BlackWalnut-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29281469661318,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-BWAL-PLTQM-wBox.png?v=1773671566&width=400",
          "product_url": "/products/smoothfinish_black-walnut_l_polytique-it",
          "product_id": 6877939171462,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Charcoal-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_charcoal_l_polytique-it",
          "product_id": 6877943103622,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-DarkOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29281507770502,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-DOAK-PLTQM-wBox.png?v=1773672391&width=400",
          "product_url": "/products/smoothfinish_dark-oak_l_polytique-it",
          "product_id": 6877951852678,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry",
          "alt": "Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-VintageCherry-Smooth.jpg?",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355453862022,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor_3de964c4-341f-4228-bd98-2bfe1c275748.jpg?v=1774880471&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_l_polytique-it",
          "product_id": 6877952737414,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-RedMahogany-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_l_polytique-it",
          "product_id": 6877952311430,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-OldOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_old-oak_l_polytique-it",
          "product_id": 6877954769030,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-ClassicBlack-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29371868741766,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK32-Box-Front_14be092d-81f9-4cdd-b275-683965480b14.png?v=1774881799&width=400",
          "product_url": "/products/smoothfinish_classic-black_l_polytique-it",
          "product_id": 6877939564678,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Java-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29281643495558,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-JAVA-PLTQS-wBox.png?v=1774882040&width=400",
          "product_url": "/products/smoothfinish_java_l_polytique-it",
          "product_id": 6877931372678,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteWash-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24360687206534,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Z-SmoothFinish-Instructions.jpg?v=1774882229&width=400",
          "product_url": "/products/smoothfinish_white-wash_l_polytique-it",
          "product_id": 6877955195014,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-PMK128-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-PMK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26115125772422,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1839623957-08fbb96080c7e0f4338da9db5003600a103af7f1530bc407964236426401c12f-d_200x150_1eb1599f-ab34-4e72-a538-a235e3ce8ecf.jpg?v=1715787114&width=400",
          "product_url": "/products/smoothfinish_white-oak_xl_polytique-it",
          "product_id": 6985221800070,
          "price": "$499.99",
          "price_num": 499.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-oak_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pecan",
          "alt": "Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Pecan-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29371941159046,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK128-PLTQM-wBox.png?v=1774884543&width=400",
          "product_url": "/products/smoothfinish_pecan_xl_polytique-it",
          "product_id": 6877954015366,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BarnWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24354439528582,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Decking_5f970801-7169-48c3-b4aa-ce806da1d38c.jpg?v=1774884946&width=400",
          "product_url": "/products/smoothfinish_barn-wood_xl_polytique-it",
          "product_id": 6877835821190,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WeatheredWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29371973599366,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK128-PLTQS-wBox.png?v=1774885589&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_xl_polytique-it",
          "product_id": 6877943529606,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BlackWalnut-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29371996700806,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK128-PLTQM-wBox.png?v=1774887843&width=400",
          "product_url": "/products/smoothfinish_black-walnut_xl_polytique-it",
          "product_id": 6877939204230,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteWash-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_white-wash_xl_polytique-it",
          "product_id": 6877955227782,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry",
          "alt": "Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-VintageCherry-Smooth.jpg?",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355061661830,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor_a57e61fe-7ecd-4a76-8c68-9e84cfdaf86c.jpg?v=1774889554&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_xl_polytique-it",
          "product_id": 6877952770182,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-DarkOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29372215558278,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK128-PLTQM-wBox.png?v=1774889238&width=400",
          "product_url": "/products/smoothfinish_dark-oak_xl_polytique-it",
          "product_id": 6877951885446,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Java-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_java_xl_polytique-it",
          "product_id": 6877931438214,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Charcoal-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_charcoal_xl_polytique-it",
          "product_id": 6877943136390,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-OldOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_old-oak_xl_polytique-it",
          "product_id": 6877954801798,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-RedMahogany-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_xl_polytique-it",
          "product_id": 6877952376966,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-ClassicBlack-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29372482912390,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK128-Front-Box_7d52135d-cb28-4382-9254-b164f132d397.png?v=1774892069&width=400",
          "product_url": "/products/smoothfinish_classic-black_xl_polytique-it",
          "product_id": 6877939597446,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-WOAK"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WOAK-BPK08-wBox_9b3deff4-b7f4-44dd-b439-90ebdbbb1ac7.png?v=1774640183&width=400",
          "product_url": "/products/smoothfinish_white-oak_s",
          "product_id": 6985221570694,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_s",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WOAK-BPK16-wBox.png?v=1774632644&width=400",
          "product_url": "/products/smoothfinish_white-oak_m",
          "product_id": 6985221406854,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_m",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WOAK-BPK32-wBox.png?v=1774877317&width=400",
          "product_url": "/products/smoothfinish_white-oak_l",
          "product_id": 6985221472390,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_l",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WOAK-BPK128-wBox.png?v=1774883792&width=400",
          "product_url": "/products/smoothfinish_white-oak_xl",
          "product_id": 6985221537926,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$299.99",
          "price_num": 299.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_xl",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18679875108998__mg_product_swatches_G4hXRR-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-PECA"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-wBox.png?v=1774542633&width=400",
          "product_url": "/products/smoothfinish_pecan_s",
          "product_id": 6877953884294,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK16-wBox.png?v=1774634877&width=400",
          "product_url": "/products/smoothfinish_pecan_m",
          "product_id": 6877953785990,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK32-wBox.png?v=1774645225&width=400",
          "product_url": "/products/smoothfinish_pecan_l",
          "product_id": 6877953818758,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK128-wBox_22582915-56d8-45b4-ac70-bb5fce69a3a0.png?v=1774888660&width=400",
          "product_url": "/products/smoothfinish_pecan_xl",
          "product_id": 6877953851526,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18679875108998__csw_custom_swatch_picker_MyBRUP-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-BARN"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-BPK08-wBox.png?v=1774640482&width=400",
          "product_url": "/products/smoothfinish_barn-wood_s",
          "product_id": 6877835460742,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-BPK16-wBox.png?v=1774635340&width=400",
          "product_url": "/products/smoothfinish_barn-wood_m",
          "product_id": 6877835133062,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-BARN-wBox.png?v=1773344197&width=400",
          "product_url": "/products/smoothfinish_barn-wood_l",
          "product_id": 6877835264134,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-BPK128-wBox.png?v=1774884714&width=400",
          "product_url": "/products/smoothfinish_barn-wood_xl",
          "product_id": 6877835362438,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18679875108998__csw_custom_swatch_picker_B4xBPj-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-WETH"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK08-wBox_68ab1fbc-ac65-4402-8ad0-64dfefa79968.png?v=1774640844&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_s",
          "product_id": 6877943398534,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK16-Products-Retail.png?v=1774635696&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_m",
          "product_id": 6877943300230,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-WETH-wBox.png?v=1773670979&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_l",
          "product_id": 6877943332998,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK128-wBox.png?v=1774885279&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_xl",
          "product_id": 6877943365766,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18679875108998__csw_custom_swatch_picker_98zn4G-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-BWAL"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK08-wBox.png?v=1774641475&width=400",
          "product_url": "/products/smoothfinish_black-walnut_s",
          "product_id": 6877939073158,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK16-wBox.png?v=1774636083&width=400",
          "product_url": "/products/smoothfinish_black-walnut_m",
          "product_id": 6877938974854,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-BWAL-wBox.png?v=1773671391&width=400",
          "product_url": "/products/smoothfinish_black-walnut_l",
          "product_id": 6877939007622,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK128-wBox_43e3c83c-b68c-4510-a9e6-838115077508.png?v=1774885770&width=400",
          "product_url": "/products/smoothfinish_black-walnut_xl",
          "product_id": 6877939040390,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18679875108998__csw_custom_swatch_picker_LtGBPa-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-WWSH"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-BPK08-wBox.png?v=1774644352&width=400",
          "product_url": "/products/smoothfinish_white-wash_s",
          "product_id": 6877955096710,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-BPK16-wBox.png?v=1774639437&width=400",
          "product_url": "/products/smoothfinish_white-wash_m",
          "product_id": 6877954998406,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-WWSH-wBox.png?v=1773675209&width=400",
          "product_url": "/products/smoothfinish_white-wash_l",
          "product_id": 6877955031174,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-BPK128-wBox.png?v=1774892623&width=400",
          "product_url": "/products/smoothfinish_white-wash_xl",
          "product_id": 6877955063942,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18679875108998__csw_custom_swatch_picker_w3RYXw-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-CHRY"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-BPK08-wBox.png?v=1774642697&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_s",
          "product_id": 6877952639110,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-BPK16-wBox.png?v=1774637716&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_m",
          "product_id": 6877952540806,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-CHRY-wBox.png?v=1773672489&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_l",
          "product_id": 6877952573574,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-BPK128-wBox.png?v=1774889337&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_xl",
          "product_id": 6877952606342,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18679875108998__csw_custom_swatch_picker_XX9LQJ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-DOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK08-wBox.png?v=1774642401&width=400",
          "product_url": "/products/smoothfinish_dark-oak_s",
          "product_id": 6877951754374,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK16-wBox.png?v=1774637440&width=400",
          "product_url": "/products/smoothfinish_dark-oak_m",
          "product_id": 6877951656070,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-DOAK-wBox.png?v=1773672181&width=400",
          "product_url": "/products/smoothfinish_dark-oak_l",
          "product_id": 6877951688838,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK128-wBox.png?v=1774889063&width=400",
          "product_url": "/products/smoothfinish_dark-oak_xl",
          "product_id": 6877951721606,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18679875108998__csw_custom_swatch_picker_NUmd6d-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-JAVA"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-BPK08-wBox.png?v=1774644013&width=400",
          "product_url": "/products/smoothfinish_java_s",
          "product_id": 6877931274374,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-BPK16-wBox.png?v=1774639016&width=400",
          "product_url": "/products/smoothfinish_java_m",
          "product_id": 6877931077766,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-JAVA-wBox.png?v=1773674960&width=400",
          "product_url": "/products/smoothfinish_java_l",
          "product_id": 6877931143302,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-BPK128-wBox.png?v=1774892185&width=400",
          "product_url": "/products/smoothfinish_java_xl",
          "product_id": 6877931208838,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18679875108998__csw_custom_swatch_picker_TzD7HF-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-CHAR"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-BPK08-wBox_84ce3a93-575c-499e-a4bb-6f28a0888d58.png?v=1774641872&width=400",
          "product_url": "/products/smoothfinish_charcoal_s",
          "product_id": 6877943005318,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-BPK16-Products-Retail.png?v=1774636536&width=400",
          "product_url": "/products/smoothfinish_charcoal_m",
          "product_id": 6877942907014,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-CHAR-wBox.png?v=1773671754&width=400",
          "product_url": "/products/smoothfinish_charcoal_l",
          "product_id": 6877942939782,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-BPK128-wBox.png?v=1774888773&width=400",
          "product_url": "/products/smoothfinish_charcoal_xl",
          "product_id": 6877942972550,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18679875108998__csw_custom_swatch_picker_eAFD8A-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-OOAK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-BPK08-wBox.png?v=1774643302&width=400",
          "product_url": "/products/smoothfinish_old-oak_s",
          "product_id": 6877954670726,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-BPK16-wBox.png?v=1774638433&width=400",
          "product_url": "/products/smoothfinish_old-oak_m",
          "product_id": 6877954572422,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-OOAK-wBox.png?v=1773674426&width=400",
          "product_url": "/products/smoothfinish_old-oak_l",
          "product_id": 6877954605190,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-BPK128-wBox.png?v=1774891206&width=400",
          "product_url": "/products/smoothfinish_old-oak_xl",
          "product_id": 6877954637958,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18679875108998__csw_custom_swatch_picker_368LdJ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-RMGY"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK08-wBox.png?v=1774642945&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_s",
          "product_id": 6877952213126,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK16-wBox.png?v=1774638020&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_m",
          "product_id": 6877952082054,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-RMGY-wBox.png?v=1773673790&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_l",
          "product_id": 6877952114822,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK128-wBox.png?v=1774889662&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_xl",
          "product_id": 6877952147590,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18679875108998__csw_custom_swatch_picker_VcPxT4-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-CBLK"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK08-wBox.png?v=1774643586&width=400",
          "product_url": "/products/smoothfinish_classic-black_s",
          "product_id": 6877939466374,
          "price": "$49.99",
          "price_num": 49.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_s",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK16-wBox.png?v=1774638723&width=400",
          "product_url": "/products/smoothfinish_classic-black_m",
          "product_id": 6877939368070,
          "price": "$59.99",
          "price_num": 59.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_m",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-CBLK-wBox.png?v=1773674691&width=400",
          "product_url": "/products/smoothfinish_classic-black_l",
          "product_id": 6877939400838,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_l",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK128-wBox.png?v=1774891850&width=400",
          "product_url": "/products/smoothfinish_classic-black_xl",
          "product_id": 6877939433606,
          "price": "$289.99",
          "price_num": 289.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_xl",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18679875108998__csw_custom_swatch_picker_cJhPw6-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Colors-PMK08-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-PMK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_white-oak_s_tripletique",
          "product_id": 6985222029446,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-oak_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pecan",
          "alt": "Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Pecan-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29348770939014,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-TPLQM-wBox.png?v=1774542740&width=400",
          "product_url": "/products/smoothfinish_pecan_s_tripletique",
          "product_id": 6877954113670,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BarnWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24348933750918,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/Tabletop_c1571228-1cbb-4ed2-8bf3-5a4896be77a7.jpg?v=1774640559&width=400",
          "product_url": "/products/smoothfinish_barn-wood_s_tripletique",
          "product_id": 6877836116102,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WeatheredWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355009376390,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK08-TPLQM-wBox.png?v=1774640916&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_s_tripletique",
          "product_id": 6877943627910,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BlackWalnut-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355026415750,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK08-TPLQM-wBox.png?v=1774641544&width=400",
          "product_url": "/products/smoothfinish_black-walnut_s_tripletique",
          "product_id": 6877939302534,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteWash-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24360721776774,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Y-Swatch-Smooth_c3048049-6a41-48e4-9d2b-94a362ff4b94.jpg?v=1774644421&width=400",
          "product_url": "/products/smoothfinish_white-wash_s_tripletique",
          "product_id": 6877955326086,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry",
          "alt": "Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-VintageCherry-Smooth.jpg?",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24356042473606,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Smooth-Small_c15ba8ba-7ee9-4c3b-a31d-bf94d30e19f3.jpg?v=1774642778&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_s_tripletique",
          "product_id": 6877952868486,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-DarkOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355089428614,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK08-TPLQM-wBox.png?v=1774642486&width=400",
          "product_url": "/products/smoothfinish_dark-oak_s_tripletique",
          "product_id": 6877952016518,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Java-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355677241478,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW-Instructions_63642f94-68a8-4209-a59f-9b19205239d6.jpg?v=1774644158&width=400",
          "product_url": "/products/smoothfinish_java_s_tripletique",
          "product_id": 6877931602054,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Charcoal-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_charcoal_s_tripletique",
          "product_id": 6877943234694,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-RedMahogany-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355102437510,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK08-TPLQG-wBox.png?v=1774643066&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_s_tripletique",
          "product_id": 6877952475270,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-OldOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355692773510,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW-Instructions_4396cdfd-3890-4f98-89eb-dd45b1ad03f6.jpg?v=1774643378&width=400",
          "product_url": "/products/smoothfinish_old-oak_s_tripletique",
          "product_id": 6877954900102,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-ClassicBlack-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355109712006,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK08-Box-3D_7de37d4f-ec9a-4ab6-b9f2-7d3fac99f7f6.png?v=1774643652&width=400",
          "product_url": "/products/smoothfinish_classic-black_s_tripletique",
          "product_id": 6877939695750,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-PMK16-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-PMK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25467236647046,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/LW-Instructions_912f3d9f-074a-47bb-9959-ebb2b50238dd.jpg?v=1774633224&width=400",
          "product_url": "/products/smoothfinish_white-oak_m_tripletique",
          "product_id": 6985222062214,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-oak_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pecan",
          "alt": "Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Pecan-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354553376902,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK16-TPLQM-wBox.png?v=1774634964&width=400",
          "product_url": "/products/smoothfinish_pecan_m_tripletique",
          "product_id": 6877954146438,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BarnWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24354569355398,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Counterop_48cdcd7e-ef80-45dc-ba14-0349ba93bcb0.jpg?v=1774635498&width=400",
          "product_url": "/products/smoothfinish_barn-wood_m_tripletique",
          "product_id": 6877836214406,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WeatheredWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25547446026374,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Front-Door-_Smooth_daed45be-d874-4fd8-a2a4-33956e4d41fb.jpg?v=1774635801&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_m_tripletique",
          "product_id": 6877943660678,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BlackWalnut-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354584047750,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK16-TPLQM-wBox.png?v=1774636173&width=400",
          "product_url": "/products/smoothfinish_black-walnut_m_tripletique",
          "product_id": 6877939335302,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteWash-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24360713322630,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Y-Swatch-Smooth_14625f1e-4657-47b5-b7d6-641fb227ca1c.jpg?v=1774639602&width=400",
          "product_url": "/products/smoothfinish_white-wash_m_tripletique",
          "product_id": 6877955358854,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry",
          "alt": "Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-VintageCherry-Smooth.jpg?",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355976740998,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Tabletop_073f744f-319b-4025-83cc-2b14c386500c.jpg?v=1774637810&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_m_tripletique",
          "product_id": 6877952901254,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-DarkOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354610917510,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK16-TPLQM-wBox.png?v=1774637514&width=400",
          "product_url": "/products/smoothfinish_dark-oak_m_tripletique",
          "product_id": 6877952049286,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Java-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_java_m_tripletique",
          "product_id": 6877931634822,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Charcoal-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_charcoal_m_tripletique",
          "product_id": 6877943267462,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-RedMahogany-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_m_tripletique",
          "product_id": 6877952508038,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-OldOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 26928016982150,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/preview_images/1927689833-5da265ac1e4602c10c6d38e72896143f45884ed9eb10c39fc0a21dd37f3287e2-d_295x166_0ac9d200-4fdb-4dcd-9b13-4f420f289552.jpg?v=1728056833&width=400",
          "product_url": "/products/smoothfinish_old-oak_m_tripletique",
          "product_id": 6877954932870,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-ClassicBlack-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29354642014342,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK16-Box-3D_01ba0796-0a55-4bb0-aca6-e59746e85e2b.png?v=1774638795&width=400",
          "product_url": "/products/smoothfinish_classic-black_m_tripletique",
          "product_id": 6877939728518,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-PMK32-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-PMK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25467235827846,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/LW-Instructions_c00d6561-ef88-4b8c-8c56-b706b942101a.jpg?v=1774877492&width=400",
          "product_url": "/products/smoothfinish_white-oak_l_tripletique",
          "product_id": 6985221996678,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-oak_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pecan",
          "alt": "Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Pecan-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29355127799942,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK32-TPLQM-wBox.png?v=1774645355&width=400",
          "product_url": "/products/smoothfinish_pecan_l_tripletique",
          "product_id": 6877954080902,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BarnWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24354535178374,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Cabinets_50a72927-c50a-4b52-89ab-0e6a0b22607a.jpg?v=1774877928&width=400",
          "product_url": "/products/smoothfinish_barn-wood_l_tripletique",
          "product_id": 6877836017798,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WeatheredWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25547411193990,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Smooth_e6c1e9c8-629c-4c29-b53b-a1ab3a84c0b3.jpg?v=1774878390&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_l_tripletique",
          "product_id": 6877943595142,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BlackWalnut-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29281466024070,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-BWAL-TPLQM-wBox.png?v=1773671464&width=400",
          "product_url": "/products/smoothfinish_black-walnut_l_tripletique",
          "product_id": 6877939269766,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteWash-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24360696381574,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Y-Swatch-Smooth_d541e734-a0d7-4bf7-8802-4283faa9cc7a.jpg?v=1774882182&width=400",
          "product_url": "/products/smoothfinish_white-wash_l_tripletique",
          "product_id": 6877955293318,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry",
          "alt": "Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-VintageCherry-Smooth.jpg?",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355456647302,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Counterop_aee22f71-409d-4483-b2d8-8fdc2e146c4b.jpg?v=1774880289&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_l_tripletique",
          "product_id": 6877952835718,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-DarkOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29281503248518,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-DOAK-TPLQM-wBox.png?v=1773672310&width=400",
          "product_url": "/products/smoothfinish_dark-oak_l_tripletique",
          "product_id": 6877951950982,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Java-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355348250758,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW-Instructions_c09455e0-43e3-471f-a1b4-deca65765f33.jpg?v=1774882002&width=400",
          "product_url": "/products/smoothfinish_java_l_tripletique",
          "product_id": 6877931536518,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Charcoal-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355161473158,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW-Instructions_04358f54-352e-4685-894a-45e3a0f4d21a.jpg?v=1774879248&width=400",
          "product_url": "/products/smoothfinish_charcoal_l_tripletique",
          "product_id": 6877943201926,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-OldOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355367682182,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW-Instructions_2ec8bf69-2bf3-4396-b36f-39268227b328.jpg?v=1774881354&width=400",
          "product_url": "/products/smoothfinish_old-oak_l_tripletique",
          "product_id": 6877954867334,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-RedMahogany-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355441049734,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/LW-Instructions_c593f226-8eda-4f8f-8981-929e4870f005.jpg?v=1774880730&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_l_tripletique",
          "product_id": 6877952442502,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-ClassicBlack-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29281610039430,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BPK32-CBLK-TPLQG-wBox.png?v=1774881742&width=400",
          "product_url": "/products/smoothfinish_classic-black_l_tripletique",
          "product_id": 6877939662982,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Colors-PMK128-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Colors-PMK08"
  },
  "rows": [
    {
      "heading": "<h2>Top Finishes for 2026</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Oak",
          "alt": "White Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25467235205254,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/products/LW-Instructions_df809908-32fa-48ea-978c-4456892cbe0b.jpg?v=1774883950&width=400",
          "product_url": "/products/smoothfinish_white-oak_xl_tripletique",
          "product_id": 6985221931142,
          "price": "$499.99",
          "price_num": 499.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-oak_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Pecan",
          "alt": "Pecan",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Pecan-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29371938275462,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK128-TPLQM-wBox.png?v=1774884447&width=400",
          "product_url": "/products/smoothfinish_pecan_xl_tripletique",
          "product_id": 6877954048134,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Barn Wood",
          "alt": "Barn Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BarnWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24354502836358,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Cabinets_f581449a-303b-43b4-8413-e135a0cdcdca.jpg?v=1774884840&width=400",
          "product_url": "/products/smoothfinish_barn-wood_xl_tripletique",
          "product_id": 6877835853958,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Weathered Wood",
          "alt": "Weathered Wood",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WeatheredWood-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 25547344085126,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Garage-Door-_Smooth_ffd2e496-30fb-4a39-ab5c-d8bb4b57690c.jpg?v=1774885433&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_xl_tripletique",
          "product_id": 6877943562374,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Black Walnut",
          "alt": "Black Walnut",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-BlackWalnut-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29371983954054,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK128-TPLQM-wBox.png?v=1774885952&width=400",
          "product_url": "/products/smoothfinish_black-walnut_xl_tripletique",
          "product_id": 6877939236998,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h2>Timeless Classics</h2>",
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "White Wash",
          "alt": "White Wash",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-WhiteWash-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24360649162886,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Smooth-Small_d0e29e46-09d6-43f0-8a10-5499a232ef96.jpg?v=1774892774&width=400",
          "product_url": "/products/smoothfinish_white-wash_xl_tripletique",
          "product_id": 6877955260550,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Cherry",
          "alt": "Cherry",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-VintageCherry-Smooth.jpg?",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24355065266310,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Counterop_840d9482-0877-4f7a-8691-834b021731c4.jpg?v=1774889437&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_xl_tripletique",
          "product_id": 6877952802950,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Dark Oak",
          "alt": "Dark Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-DarkOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29372209135750,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK128-TPLQM-wBox.png?v=1774889151&width=400",
          "product_url": "/products/smoothfinish_dark-oak_xl_tripletique",
          "product_id": 6877951918214,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Java",
          "alt": "Java",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Java-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24367894397062,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Kitchen-Cabinets_8d2fbb76-0cc2-4093-950d-e5a34252faf6.jpg?v=1774892276&width=400",
          "product_url": "/products/smoothfinish_java_xl_tripletique",
          "product_id": 6877931503750,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "popup_remaining_swatches_trigger",
          "button_text": "<h1>View All</h1>",
          "button_style": "swatch",
          "button_margin_top": "10",
          "popup_swatches_per_row_mobile": 0,
          "popup_swatches_per_row_desktop": 0,
          "include_visible_swatches_in_popup": true,
          "button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "button_image_alt": "View All",
          "preset_button_image": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK-ViewAll-Image.png?v=1776982356&width=1600",
          "preset_button_image_alt": "View All",
          "popup_title": ""
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Charcoal",
          "alt": "Charcoal",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-Charcoal-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 24354954018950,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/Swatch-Smooth-Small_ef300677-8119-45e1-bd5c-7d09241c4409.jpg?v=1774888859&width=400",
          "product_url": "/products/smoothfinish_charcoal_xl_tripletique",
          "product_id": 6877943169158,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Red Mahogany",
          "alt": "Red Mahogany",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-RedMahogany-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29372259172486,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK128-Hero-Box_81752504-9ab7-4cfc-a19f-43f8cfb4f3b8.png?v=1774890091&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_xl_tripletique",
          "product_id": 6877952409734,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Old Oak",
          "alt": "Old Oak",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-OldOak-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29372444409990,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-BPK128-TPLQS-wBox.png?v=1774891346&width=400",
          "product_url": "/products/smoothfinish_old-oak_xl_tripletique",
          "product_id": 6877954834566,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Classic Black",
          "alt": "Classic Black",
          "thumbnail": "https://cdn.shopify.com/s/files/1/0066/5993/2278/files/SwatchSmall-ClassicBlack-Smooth.jpg",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "override",
          "product_image_id": 29372481962118,
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK128-TPLQS-wBox.png?v=1774891996&width=400",
          "product_url": "/products/smoothfinish_classic-black_xl_tripletique",
          "product_id": 6877939630214,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-WOAK-TPLQ"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WOAK-BPK08-TPLQM_Table.png?v=1774640259&width=400",
          "product_url": "/products/smoothfinish_white-oak_s_tripletique",
          "product_id": 6985222029446,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_s_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WOAK-TPLQ-Matte_Table.png?v=1774633224&width=400",
          "product_url": "/products/smoothfinish_white-oak_m_tripletique",
          "product_id": 6985222062214,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_m_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WOAK-BPK32-TPLQ-Matte_table.png?v=1774877492&width=400",
          "product_url": "/products/smoothfinish_white-oak_l_tripletique",
          "product_id": 6985221996678,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_l_tripletique",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WOAK-BPK128_table_214c0758-53ce-4160-adbd-e9226a5a3506.png?v=1774883950&width=400",
          "product_url": "/products/smoothfinish_white-oak_xl_tripletique",
          "product_id": 6985221931142,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$499.99",
          "price_num": 499.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_xl_tripletique",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18680043077766__mg_product_swatches_G4hXRR-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-PECA-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WNK08-TPLQS-wBox.png?v=1774542740&width=400",
          "product_url": "/products/smoothfinish_pecan_s_tripletique",
          "product_id": 6877954113670,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-TPLQ-Matte_Table.png?v=1774634964&width=400",
          "product_url": "/products/smoothfinish_pecan_m_tripletique",
          "product_id": 6877954146438,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK32-TPLQ-Matte_table.png?v=1774645355&width=400",
          "product_url": "/products/smoothfinish_pecan_l_tripletique",
          "product_id": 6877954080902,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK128-TPLQ-Matte_table.png?v=1774884447&width=400",
          "product_url": "/products/smoothfinish_pecan_xl_tripletique",
          "product_id": 6877954048134,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680043077766__csw_custom_swatch_picker_MyBRUP-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-BARN-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-BPK08-TPLQM_Table.png?v=1774640559&width=400",
          "product_url": "/products/smoothfinish_barn-wood_s_tripletique",
          "product_id": 6877836116102,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-TPLQ-Matte_Table.png?v=1774635498&width=400",
          "product_url": "/products/smoothfinish_barn-wood_m_tripletique",
          "product_id": 6877836214406,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-BPK32-TPLQ-Matte_table.png?v=1774877928&width=400",
          "product_url": "/products/smoothfinish_barn-wood_l_tripletique",
          "product_id": 6877836017798,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-BPK128-TPLQ-Matte_table.png?v=1774884840&width=400",
          "product_url": "/products/smoothfinish_barn-wood_xl_tripletique",
          "product_id": 6877835853958,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680043077766__csw_custom_swatch_picker_B4xBPj-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-WETH-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK08-TPLQM_Table.png?v=1774640916&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_s_tripletique",
          "product_id": 6877943627910,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-TPLQ-Matte_Table.png?v=1774635801&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_m_tripletique",
          "product_id": 6877943660678,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK32-TPLQ-Matte_table.png?v=1774878390&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_l_tripletique",
          "product_id": 6877943595142,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK128-TPLQ-Matte_table.png?v=1774885433&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_xl_tripletique",
          "product_id": 6877943562374,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680043077766__csw_custom_swatch_picker_98zn4G-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-BWAL-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK08-TPLQM_Table.png?v=1774641544&width=400",
          "product_url": "/products/smoothfinish_black-walnut_s_tripletique",
          "product_id": 6877939302534,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-TPLQ-Matte_Table.png?v=1774636173&width=400",
          "product_url": "/products/smoothfinish_black-walnut_m_tripletique",
          "product_id": 6877939335302,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK32-TPLQ-Matte_table.png?v=1774878706&width=400",
          "product_url": "/products/smoothfinish_black-walnut_l_tripletique",
          "product_id": 6877939269766,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK128-TPLQ-Matte_table.png?v=1774885952&width=400",
          "product_url": "/products/smoothfinish_black-walnut_xl_tripletique",
          "product_id": 6877939236998,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680043077766__csw_custom_swatch_picker_LtGBPa-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-WWSH-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-BPK08-TPLQM_Table.png?v=1774644421&width=400",
          "product_url": "/products/smoothfinish_white-wash_s_tripletique",
          "product_id": 6877955326086,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-TPLQ-Matte_Table_7f58caa9-5ec6-42bf-89cb-fa03ad322c9e.png?v=1774639602&width=400",
          "product_url": "/products/smoothfinish_white-wash_m_tripletique",
          "product_id": 6877955358854,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-BPK32-TPLQ-Matte_table.png?v=1774882182&width=400",
          "product_url": "/products/smoothfinish_white-wash_l_tripletique",
          "product_id": 6877955293318,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-BPK128-TPLQ-Matte_table.png?v=1774892774&width=400",
          "product_url": "/products/smoothfinish_white-wash_xl_tripletique",
          "product_id": 6877955260550,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680043077766__csw_custom_swatch_picker_w3RYXw-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-CHRY-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-BPK08-TPLQM_Table.png?v=1774642778&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_s_tripletique",
          "product_id": 6877952868486,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-TPLQ-Matte_Table.png?v=1774637810&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_m_tripletique",
          "product_id": 6877952901254,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-BPK32-TPLQ-Matte_table.png?v=1774880289&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_l_tripletique",
          "product_id": 6877952835718,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-BPK128-TPLQ-Matte_table.png?v=1774889437&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_xl_tripletique",
          "product_id": 6877952802950,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680043077766__csw_custom_swatch_picker_XX9LQJ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-DOAK-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK08-TPLQM_Table.png?v=1774642486&width=400",
          "product_url": "/products/smoothfinish_dark-oak_s_tripletique",
          "product_id": 6877952016518,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-TPLQ-Matte_Table.png?v=1774637514&width=400",
          "product_url": "/products/smoothfinish_dark-oak_m_tripletique",
          "product_id": 6877952049286,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK32-TPLQ-Matte_table.png?v=1774879903&width=400",
          "product_url": "/products/smoothfinish_dark-oak_l_tripletique",
          "product_id": 6877951950982,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK128-TPLQ-Matte_table.png?v=1774889151&width=400",
          "product_url": "/products/smoothfinish_dark-oak_xl_tripletique",
          "product_id": 6877951918214,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680043077766__csw_custom_swatch_picker_NUmd6d-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-JAVA-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-BPK08-TPLQM_Table.png?v=1774644158&width=400",
          "product_url": "/products/smoothfinish_java_s_tripletique",
          "product_id": 6877931602054,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-TPLQ-Matte_Table.png?v=1774639239&width=400",
          "product_url": "/products/smoothfinish_java_m_tripletique",
          "product_id": 6877931634822,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-BPK32-TPLQ-Matte_table.png?v=1774882002&width=400",
          "product_url": "/products/smoothfinish_java_l_tripletique",
          "product_id": 6877931536518,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-BPK128-TPLQ-Matte_table.png?v=1774892276&width=400",
          "product_url": "/products/smoothfinish_java_xl_tripletique",
          "product_id": 6877931503750,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680043077766__csw_custom_swatch_picker_TzD7HF-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-CHAR-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-BPK08-TPLQM_Table.png?v=1774642104&width=400",
          "product_url": "/products/smoothfinish_charcoal_s_tripletique",
          "product_id": 6877943234694,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-TPLQ-Matte_Table_b39638b5-4aaa-4669-be5c-65678f613f61.png?v=1774636720&width=400",
          "product_url": "/products/smoothfinish_charcoal_m_tripletique",
          "product_id": 6877943267462,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-BPK32-TPLQ-Matte_table.png?v=1774879248&width=400",
          "product_url": "/products/smoothfinish_charcoal_l_tripletique",
          "product_id": 6877943201926,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-BPK128-TPLQ-Matte_table.png?v=1774888859&width=400",
          "product_url": "/products/smoothfinish_charcoal_xl_tripletique",
          "product_id": 6877943169158,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680043077766__csw_custom_swatch_picker_eAFD8A-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-OOAK-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-BPK08-TPLQM_Table.png?v=1774643378&width=400",
          "product_url": "/products/smoothfinish_old-oak_s_tripletique",
          "product_id": 6877954900102,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-TPLQ-Matte_Table.png?v=1774638519&width=400",
          "product_url": "/products/smoothfinish_old-oak_m_tripletique",
          "product_id": 6877954932870,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-BPK32-TPLQ-Matte_table.png?v=1774881354&width=400",
          "product_url": "/products/smoothfinish_old-oak_l_tripletique",
          "product_id": 6877954867334,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-BPK128-TPLQ-Matte_table.png?v=1774891346&width=400",
          "product_url": "/products/smoothfinish_old-oak_xl_tripletique",
          "product_id": 6877954834566,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680043077766__csw_custom_swatch_picker_368LdJ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-RMGY-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK08-TPLQM_Table.png?v=1774643066&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_s_tripletique",
          "product_id": 6877952475270,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-TPLQ-Matte_Table.png?v=1774638106&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_m_tripletique",
          "product_id": 6877952508038,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK32-TPLQ-Matte_table.png?v=1774880730&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_l_tripletique",
          "product_id": 6877952442502,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK128-TPLQ-Matte_table.png?v=1774890091&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_xl_tripletique",
          "product_id": 6877952409734,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680043077766__csw_custom_swatch_picker_VcPxT4-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-CBLK-TPLQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK08-TPLQM_Table.png?v=1774643652&width=400",
          "product_url": "/products/smoothfinish_classic-black_s_tripletique",
          "product_id": 6877939695750,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_s_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-TPLQ-Matte_Table.png?v=1774638795&width=400",
          "product_url": "/products/smoothfinish_classic-black_m_tripletique",
          "product_id": 6877939728518,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_m_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK32-TPLQ-Matte_table.png?v=1774881742&width=400",
          "product_url": "/products/smoothfinish_classic-black_l_tripletique",
          "product_id": 6877939662982,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_l_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK128-TPLQ-Matte_table.png?v=1774891996&width=400",
          "product_url": "/products/smoothfinish_classic-black_xl_tripletique",
          "product_id": 6877939630214,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_xl_tripletique",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680043077766__csw_custom_swatch_picker_cJhPw6-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-WOAK-PLTQ"] = {
  "meta": {
    "appearance": {
      "border_color": "#cfcfcf",
      "border_size": 1,
      "shadow_size": 6,
      "background_color": "#ffffff",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#ffffff",
      "gradient_angle": 144,
      "text_style": "same"
    },
    "selected_appearance": {
      "border_color": "#6f719b",
      "border_size": 2,
      "shadow_size": 6,
      "background_color": "#faf7e9",
      "border_scope": "image_text",
      "text_color": "",
      "text_behavior": "squeeze_text",
      "text_size_mobile": 12,
      "text_size_desktop": 20,
      "border_radius_px": 12,
      "image_radius_px": 0,
      "product_image_padding": 0,
      "gradient_color": "#faf7e9",
      "gradient_angle": 144,
      "text_style": "normal"
    },
    "corner_radius_px": 12
  },
  "rows": [
    {
      "block_type": "mg_row",
      "heading_justify": "center",
      "img_ratio": "1:1",
      "row_height": "0",
      "row_height_mobile": "0",
      "row_height_desktop": "0",
      "fit_row": true,
      "row_display_type_mobile": "scale_to_fit",
      "row_display_type_desktop": "scale_to_fit",
      "row_display_type": "scale_to_fit",
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": true,
      "row_justify": "center",
      "swatches_per_row_mobile": 0,
      "swatches_per_row_desktop": 0,
      "swatches_per_row": 0,
      "padding_between_rows_mobile": 0,
      "padding_between_rows_desktop": 0,
      "padding_between_rows": 0,
      "swatch_image_zoom": "100",
      "swatch_vertical_justify": "fit_to_height",
      "randomize_zoom_area": false,
      "random_zoom_max": "0",
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WOAK-BPK08-PLTQM_Table.png?v=1774640348&width=400",
          "product_url": "/products/smoothfinish_white-oak_s_polytique-it",
          "product_id": 6985221636230,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_s_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WOAK-PLTQ-Matte_Table.png?v=1774634341&width=400",
          "product_url": "/products/smoothfinish_white-oak_m_polytique-it",
          "product_id": 6985221668998,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_m_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WOAK-BPK32-PLTQ-Matte_table.png?v=1774877684&width=400",
          "product_url": "/products/smoothfinish_white-oak_l_polytique-it",
          "product_id": 6985221734534,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_l_polytique-it",
            "text": "Shop"
          }
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WOAK-BPK128-PLTQ-Matte_table.png?v=1774884096&width=400",
          "product_url": "/products/smoothfinish_white-oak_xl_polytique-it",
          "product_id": 6985221800070,
          "show_price": true,
          "show_reviews": false,
          "show_shop_button": false,
          "buttons_over_image": false,
          "price": "$499.99",
          "price_num": 499.99,
          "available": true,
          "vjust": "center",
          "html_desc": "",
          "desc_html": "",
          "margin_top": 0,
          "margin_bottom": 0,
          "open_set_key": "",
          "learn_more_text": "",
          "cta": {
            "href": "/products/smoothfinish_white-oak_xl_polytique-it",
            "text": "Shop"
          }
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "heading_justify": "center",
      "custom_template_id": "mgps-custom-template--18680131813510__mg_product_swatches_G4hXRR-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "custom_width_desktop_percent": "100",
      "custom_width_mobile_percent": "100",
      "custom_max_width_px": "0",
      "img_ratio": "1:1",
      "row_height": 0,
      "fit_row": false,
      "margin_top": 0,
      "margin_bottom": 0,
      "swatch_row": false,
      "row_justify": "center",
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-PECA-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/image-75_27c1dde0-937b-4bee-9337-1ba74202d2d5.png?v=1769444947&width=400",
          "product_url": "/products/smoothfinish_pecan_s_polytique-it",
          "product_id": 6877953917062,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-PLTQ-Matte_Table.png?v=1774635035&width=400",
          "product_url": "/products/smoothfinish_pecan_m_polytique-it",
          "product_id": 6877953949830,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK32-PLTQ-Matte_table.png?v=1774645506&width=400",
          "product_url": "/products/smoothfinish_pecan_l_polytique-it",
          "product_id": 6877953982598,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/PECA-BPK128-PLTQ-Matte_table.png?v=1774884543&width=400",
          "product_url": "/products/smoothfinish_pecan_xl_polytique-it",
          "product_id": 6877954015366,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_pecan_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680131813510__csw_custom_swatch_picker_MyBRUP-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-BARN-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-BPK08-PLTQM_Table.png?v=1774640648&width=400",
          "product_url": "/products/smoothfinish_barn-wood_s_polytique-it",
          "product_id": 6877835559046,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-PLTQ-Matte_Table.png?v=1774635581&width=400",
          "product_url": "/products/smoothfinish_barn-wood_m_polytique-it",
          "product_id": 6877835624582,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-BPK32-PLTQ-Matte_table.png?v=1774878069&width=400",
          "product_url": "/products/smoothfinish_barn-wood_l_polytique-it",
          "product_id": 6877835755654,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BARN-BPK128-PLTQ-Matte_table.png?v=1774884946&width=400",
          "product_url": "/products/smoothfinish_barn-wood_xl_polytique-it",
          "product_id": 6877835821190,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_barn-wood_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680131813510__csw_custom_swatch_picker_B4xBPj-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-WETH-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK08-PLTQM_Table.png?v=1774641000&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_s_polytique-it",
          "product_id": 6877943431302,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-PLTQ-Matte_Table.png?v=1774635909&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_m_polytique-it",
          "product_id": 6877943464070,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK32-PLTQ-Matte_table.png?v=1774878461&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_l_polytique-it",
          "product_id": 6877943496838,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WETH-BPK128-PLTQ-Matte_table.png?v=1774885589&width=400",
          "product_url": "/products/smoothfinish_weathered-wood_xl_polytique-it",
          "product_id": 6877943529606,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_weathered-wood_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680131813510__csw_custom_swatch_picker_98zn4G-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-BWAL-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK08-PLTQM_Table.png?v=1774641685&width=400",
          "product_url": "/products/smoothfinish_black-walnut_s_polytique-it",
          "product_id": 6877939105926,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor_7e78697b-62e3-4380-aac5-8f347fce812c.jpg?v=1774636264&width=400",
          "product_url": "/products/smoothfinish_black-walnut_m_polytique-it",
          "product_id": 6877939138694,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK32-PLTQ-Matte_table.png?v=1774878816&width=400",
          "product_url": "/products/smoothfinish_black-walnut_l_polytique-it",
          "product_id": 6877939171462,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/BWAL-BPK128-PLTQ-Matte_table.png?v=1774887843&width=400",
          "product_url": "/products/smoothfinish_black-walnut_xl_polytique-it",
          "product_id": 6877939204230,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_black-walnut_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680131813510__csw_custom_swatch_picker_LtGBPa-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-WWSH-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-BPK08-PLTQM_Table.png?v=1774644517&width=400",
          "product_url": "/products/smoothfinish_white-wash_s_polytique-it",
          "product_id": 6877955129478,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-PLTQ-Matte_Table_0c3e3f7b-f332-45d7-a5a4-e9ea91848382.png?v=1774639766&width=400",
          "product_url": "/products/smoothfinish_white-wash_m_polytique-it",
          "product_id": 6877955162246,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-BPK32-PLTQ-Matte_table.png?v=1774882229&width=400",
          "product_url": "/products/smoothfinish_white-wash_l_polytique-it",
          "product_id": 6877955195014,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/WWSH-BPK128-PLTQ-Matte_table.png?v=1774893216&width=400",
          "product_url": "/products/smoothfinish_white-wash_xl_polytique-it",
          "product_id": 6877955227782,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_white-wash_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680131813510__csw_custom_swatch_picker_w3RYXw-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-CHRY-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-BPK08-PLTQM_Table.png?v=1774642873&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_s_polytique-it",
          "product_id": 6877952671878,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-PLTQ-Matte_Table.png?v=1774637914&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_m_polytique-it",
          "product_id": 6877952704646,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-BPK32-PLTQ-Matte_table.png?v=1774880471&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_l_polytique-it",
          "product_id": 6877952737414,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHRY-BPK128-PLTQ-Matte_table.png?v=1774889554&width=400",
          "product_url": "/products/smoothfinish_vintage-cherry_xl_polytique-it",
          "product_id": 6877952770182,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_vintage-cherry_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680131813510__csw_custom_swatch_picker_XX9LQJ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-DOAK-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK08-PLTQM_Table.png?v=1774642606&width=400",
          "product_url": "/products/smoothfinish_dark-oak_s_polytique-it",
          "product_id": 6877951787142,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor_64c06239-a8d1-40b8-9e13-82af4f622e50.jpg?v=1774637603&width=400",
          "product_url": "/products/smoothfinish_dark-oak_m_polytique-it",
          "product_id": 6877951819910,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK32-PLTQ-Matte_table.png?v=1774879993&width=400",
          "product_url": "/products/smoothfinish_dark-oak_l_polytique-it",
          "product_id": 6877951852678,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DOAK-BPK128-PLTQ-Matte_table.png?v=1774889238&width=400",
          "product_url": "/products/smoothfinish_dark-oak_xl_polytique-it",
          "product_id": 6877951885446,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_dark-oak_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680131813510__csw_custom_swatch_picker_NUmd6d-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-JAVA-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-BPK08-PLTQM_Table.png?v=1774644256&width=400",
          "product_url": "/products/smoothfinish_java_s_polytique-it",
          "product_id": 6877931307142,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-PLTQ-Matte_Table.png?v=1774639319&width=400",
          "product_url": "/products/smoothfinish_java_m_polytique-it",
          "product_id": 6877931339910,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-BPK32-PLTQ-Matte_table.png?v=1774882040&width=400",
          "product_url": "/products/smoothfinish_java_l_polytique-it",
          "product_id": 6877931372678,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/JAVA-BPK128-PLTQ-Matte_table.png?v=1774892451&width=400",
          "product_url": "/products/smoothfinish_java_xl_polytique-it",
          "product_id": 6877931438214,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_java_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680131813510__csw_custom_swatch_picker_TzD7HF-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-CHAR-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-BPK08-PLTQM_Table.png?v=1774642246&width=400",
          "product_url": "/products/smoothfinish_charcoal_s_polytique-it",
          "product_id": 6877943038086,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-PLTQ-Matte_Table.png?v=1774636896&width=400",
          "product_url": "/products/smoothfinish_charcoal_m_polytique-it",
          "product_id": 6877943070854,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-BPK32-PLTQ-Matte_table.png?v=1774879504&width=400",
          "product_url": "/products/smoothfinish_charcoal_l_polytique-it",
          "product_id": 6877943103622,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CHAR-BPK128-PLTQ-Matte_table.png?v=1774888953&width=400",
          "product_url": "/products/smoothfinish_charcoal_xl_polytique-it",
          "product_id": 6877943136390,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_charcoal_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680131813510__csw_custom_swatch_picker_eAFD8A-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-OOAK-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-BPK08-PLTQM_Table.png?v=1774643458&width=400",
          "product_url": "/products/smoothfinish_old-oak_s_polytique-it",
          "product_id": 6877954703494,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-PLTQ-Matte_Table.png?v=1774638617&width=400",
          "product_url": "/products/smoothfinish_old-oak_m_polytique-it",
          "product_id": 6877954736262,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-BPK32-PLTQ-Matte_table.png?v=1774881404&width=400",
          "product_url": "/products/smoothfinish_old-oak_l_polytique-it",
          "product_id": 6877954769030,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/OOAK-BPK128-PLTQ-Matte_table.png?v=1774891569&width=400",
          "product_url": "/products/smoothfinish_old-oak_xl_polytique-it",
          "product_id": 6877954801798,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_old-oak_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680131813510__csw_custom_swatch_picker_368LdJ-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-RMGY-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK08-PLTQM_Table.png?v=1774643202&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_s_polytique-it",
          "product_id": 6877952245894,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-PLTQ-Matte_Table.png?v=1774638190&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_m_polytique-it",
          "product_id": 6877952278662,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK32-PLTQ-Matte_table.png?v=1774880861&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_l_polytique-it",
          "product_id": 6877952311430,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/RMGY-BPK128-PLTQ-Matte_table.png?v=1774890240&width=400",
          "product_url": "/products/smoothfinish_red-mahogany_xl_polytique-it",
          "product_id": 6877952376966,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_red-mahogany_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680131813510__csw_custom_swatch_picker_VcPxT4-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};
window.MG_SWATCH_SETS["Sizes-PMK-CBLK-PLTQ"] = {
  "meta": {
    "match_settings_preset_key": "Sizes-PMK-WOAK"
  },
  "rows": [
    {
      "block_type": "mg_row",
      "swatch_row": true,
      "swatches": [
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Small Kit",
          "alt": "Small Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK08-PLTQM_Table.png?v=1774643807&width=400",
          "product_url": "/products/smoothfinish_classic-black_s_polytique-it",
          "product_id": 6877939499142,
          "price": "$74.99",
          "price_num": 74.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_s_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Medium Kit",
          "alt": "Medium Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/DoubleFrontDoor_4516d19e-de7c-415e-b634-3cb2a4c8e826.jpg?v=1774638892&width=400",
          "product_url": "/products/smoothfinish_classic-black_m_polytique-it",
          "product_id": 6877939531910,
          "price": "$99.99",
          "price_num": 99.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_m_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "Large Kit",
          "alt": "Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK32-PLTQ-Matte_table.png?v=1774881799&width=400",
          "product_url": "/products/smoothfinish_classic-black_l_polytique-it",
          "product_id": 6877939564678,
          "price": "$169.99",
          "price_num": 169.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_l_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        },
        {
          "type": "product",
          "swatch_mode": true,
          "title": "4x Large Kit",
          "alt": "4x Large Kit",
          "swatch_vertical_justify": "bottom",
          "thumb_mode": "default",
          "product_image_url": "//cdn.shopify.com/s/files/1/0066/5993/2278/files/CBLK-BPK128-PLTQ-Matte_table.png?v=1774892069&width=400",
          "product_url": "/products/smoothfinish_classic-black_xl_polytique-it",
          "product_id": 6877939597446,
          "price": "$449.99",
          "price_num": 449.99,
          "available": true,
          "cta": {
            "href": "/products/smoothfinish_classic-black_xl_polytique-it",
            "text": "Shop"
          },
          "swatch_image_zoom": "100",
          "scale": "100",
          "product_image_scale": "100"
        }
      ]
    },
    {
      "heading": "<h3></h3><h3>Estimated Coverage by Size</h3>",
      "custom_template_id": "mgps-custom-template--18680131813510__csw_custom_swatch_picker_cJhPw6-0",
      "custom_html": "<div style=\"display: flex; justify-content: center;\">\n  <ul style=\"list-style-position: inside; text-align: left;\">\n    <li>Small Kit - 25 square feet</li>\n    <li>Medium Kit - 50 square feet</li>\n    <li>Large Kit - 100 square feet</li>\n    <li>4x Large Kit - 400 square feet</li>\n  </ul>\n</div>\n<br>",
      "swatch_row": false,
      "swatches": []
    }
  ]
};